/**
 * @file The purchase album layout container.
 */

import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import PurchaseAlbumLayout from '../../views/layouts/PurchaseAlbumLayout';

export default compose(withRouter)(PurchaseAlbumLayout);
